import {
  BaseOrderingStore,
  OnlineOrder,
  OnlineOrderingStore
} from 'kiolyn-api';
import moment from 'moment-timezone';
import { isNullOrUndefined } from 'util';
import { defaultTimezone, timestampFormat } from '../models/Constants';
import { getApplyTax } from './KioskApplyTax';
import newId from './NewId';

/**
 * Create new Order for a given online store.
 *
 * @export
 * @param {*} store
 * @returns
 */
export default function newOrder(
  store?: BaseOrderingStore,
  orderOld?: OnlineOrder
): OnlineOrder {
  let order: OnlineOrder = {
    id: newId(),
    name: '',
    type: 'online-order',
    items: [],
    tax_amount: 0,
    subtotal: 0,
    delivery_fee_amount: 0,
    total: 0,
    tax: {
      id: '',
      percent: 0,
      name: '',
      type: 'tax'
    },
    order_type: orderOld?.order_type || 'pickup',
    customer_name: '',
    customer_first_name: '',
    customer_last_name: '',
    customer_email: '',
    customer_address: '',
    customer_phone: '',
    customer_zip: '',
    customer_state: 'CA',
    customer_city: '',
    customer_place_unit: '',
    card: {
      name: '',
      cvc: '',
      number: '',
      expiry: ''
    },
    billing_address: '',
    billing_phone: '',
    // billing_zip: '',
    // billing_state: 'CA',
    // billing_city: '',
    is_asap: orderOld?.is_asap !== undefined ? orderOld.is_asap : true,
    time: orderOld?.time
  };

  if (!isNullOrUndefined(store)) {
    order.storeid = store.id;
    if (!isNullOrUndefined(store.tax) && getApplyTax(store)) {
      order.tax = { ...store.tax };
    }

    var pauseOrder = (store as OnlineOrderingStore).pause_online_ordering;
    if (pauseOrder) {
      const time = moment()
        .tz(store.timezone || defaultTimezone)
        .add(pauseOrder, 'h');
      order.time = time.format(timestampFormat);
      order.timeIsoFormat = time.format();
      order.is_asap = false;
    }
  }

  return order;
}
